import { FC, Ref } from "react";
import cn from "classnames";
import { DiscountBrandType } from "src/Modules/Discounts/types";
import { Link } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";
import DiscountCardImage from "./components/DiscountCardImage/DiscountCardImage";
import DiscountCardDetails from "./components/DiscountCardDetails/DiscountCardDetails";

type DiscountsCardProps = Partial<DiscountBrandType> & {
  loading?: boolean;
  onClick?: () => void;
  code: string;
  background?: string | null;
  shapeRef?: Ref<HTMLDivElement>;
  seamRef?: Ref<HTMLDivElement>;
};

const DiscountCard: FC<DiscountsCardProps> = ({ imageUrl, name, items = [], loading, code, background, shapeRef, seamRef }) => {
  const category = items[0]?.categories?.[0];

  const card = (
    <div
      ref={shapeRef}
      className={cn("h-full overflow-hidden", !background && "bg-background-default rounded-lg")}
      style={background ? { backgroundImage: `url(${background})`, backgroundSize: "100% 100%", backgroundRepeat: "no-repeat" } : undefined}
    >
      <div ref={seamRef} className="p-3 pb-5 md:p-3 md:pb-4">
        <DiscountCardImage imageUrl={imageUrl} name={name} items={items} loading={loading} />
      </div>
      <div className="flex flex-col gap-3 px-5 p-4 pt-4 md:gap-2 md:pt-4">
        <DiscountCardDetails name={name} items={items} loading={loading} />
      </div>
    </div>
  );

  if (loading) return <div className="font-inter block h-full drop-shadow-sm">{card}</div>;

  return (
    <Link
      to={`${code}`}
      className="group font-inter block h-full drop-shadow-sm hover:drop-shadow-xs transition-all"
      onClick={() => track("Card Selected", { code, name, category })}
    >
      {card}
    </Link>
  );
};

export default DiscountCard;
